module.exports = __webpack_public_path__ + "static/media/mouse-pointer.0abb7383.svg";